import { Col, Form, Input, message, Row, Select } from 'antd'
import withSpinning from '../../../../elements/HOC/withSpinning'
import withUrlFetch from '../../../../elements/Select/withUrlFetch'
import CustomSpin from '../../../../elements/CustomSpin'
import Members from '../../../../api/Members'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withLoadingSection from '../../../../elements/HOC/withLoadingSection'
import withSort from '../../../../elements/HOC/withSort'
import InfoText from '../../../../elements/InfoText'
import CountrySelect from '../../../../elements/Select/Country'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import { get, isEmpty } from 'lodash'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import React, { Component } from 'react'
import { compose } from 'recompose'

const FormItem = Form.Item

class Communication extends Component {
  state = {
    SupplierRepSelect: Select,
    fetching: false,
    companyReps: [],
    supplierReps: [],
    CompanyRepSelect: Select,
  }
  membersApi = new Members()

  componentDidMount() {
    this.fetchSupplierReps()
    this.fetchCompanyReps()
  }

  onChangeBillingRep = (owner) => {
    const rep = this.state.supplierReps.find((r) => r.owner === owner) || {}
    this.props.form.setFieldsValue({
      'payableRep.phone.label': rep.phone || rep.mobile,
      'payableRep.email.label': rep.email,
      'payableRep.address.label': rep.address,
    })
  }
  onChangeClientRep = (owner) => {
    const rep = this.state.supplierReps.find((r) => r.owner === owner) || {}
    this.props.form.setFieldsValue({
      'lenderRep.phone.label': rep.phone || rep.mobile,
      'lenderRep.email.label': rep.email,
      'lenderRep.address.label': rep.address,
    })
  }
  onChangeCompanyRep = (owner) => {
    const rep = this.state.companyReps.find((r) => r.owner === owner) || {}
    this.props.form.setFieldsValue({
      'companyRep.phone.label': rep.phone || rep.mobile,
      'companyRep.email.label': rep.email,
    })
  }
  fetchSupplierReps = async () => {
    const supplier = get(this.props, 'supplier.owner') || get(this.props, 'contract.owner._id')
    const member = get(this.props, 'member')

    if (!isEmpty(supplier)) {
      try {
        this.setState({
          fetching: true,
        })
        let data = []
        if (member.kind !== 'individual') {
          const response = await this.membersApi.representatives.list(supplier.replace('members/', ''))
          data = await response.json()
        } else {
          const mappedMember = {
            repID: member._key,
            owner: member._id,
            name: member.fn,
            email: get(member, 'email.label'),
            phone: get(member, 'phone.label'),
            mobile: get(member, 'mobile.label'),
          }
          data = [mappedMember]
        }

        console.log(1111111, data)
        const SupplierRepSelect = compose(
          withData({
            data,
          }),
          withSort
        )(CustomSelect)

        this.setState({
          supplierReps: data,
          SupplierRepSelect,
          fetching: false,
        })
      } catch (e) {
        this.setState({
          fetching: false,
        })
        message.error(e.errorMessage)
      }
    }
  }
  fetchCompanyReps = async () => {
    console.log('fetchCompanyReps')

    const company = get(this.props, 'contract.company._id')
    if (!isEmpty(company)) {
      try {
        this.setState({
          fetching: true,
        })
        const response = await this.membersApi.representatives.list(company.replace('members/', ''))
        const data = await response.json()
        const CompanyRepSelect = compose(
          withData({
            data,
          }),
          withSort
        )(CustomSelect)
        this.setState({
          companyReps: data,
          CompanyRepSelect,
          fetching: false,
        })
      } catch (e) {
        this.setState({
          fetching: false,
        })
        message.error(e.errorMessage)
      }
    }
  }

  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const { contract, type, supplier, member } = this.props
    const { SupplierRepSelect, CompanyRepSelect, fetching } = this.state

    const LenderRepEmailSelect = compose(
      withUrlFetch({
        name: 'lenderRep',
        url: `contacts/email/${(getFieldValue('lenderRep._id') || '').replace('members/', '')}`,
        dontFetch: isEmpty(getFieldValue('lenderRep._id')),
      }),
      withSpinning
    )(CustomSelect)

    const CompanyRepEmailSelect = compose(
      withUrlFetch({
        name: 'companyRep',
        url: `contacts/email/${(getFieldValue('companyRep._id') || '').replace('members/', '')}`,
        dontFetch: isEmpty(getFieldValue('companyRep._id')),
      }),
      withSpinning
    )(CustomSelect)

    const PayableEmailSelect = compose(
      withUrlFetch({
        name: 'payableRep',
        url: `contacts/email/${(getFieldValue('payableRep._id') || '').replace('members/', '')}`,
        dontFetch: isEmpty(getFieldValue('payableRep._id')),
      }),
      withSpinning
    )(CustomSelect)

    return (
      <Form layout="horizontal">
        <FormSectionTitle title={'PARTNER NOTICE ADDRESS'} />
        <Row>
          <Col span={12}>
            <Form.Item label="Country" {...defaultFormItemLayout}>
              {getFieldDecorator('lender.address.country', {
                initialValue: get(contract, 'lender.address.country') || get(member, 'address.country'),
                rules: [
                  {
                    required: true,
                    message: "Country can't be empty ",
                  },
                ],
              })(<CountrySelect />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Postcode" {...defaultFormItemLayout}>
              {getFieldDecorator('lender.address.postcode', {
                initialValue: get(contract, 'lender.address.postcode') || get(member, 'address.postcode'),
              })(<Input placeholder="Postcode" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="Street" {...defaultFormItemLayout}>
              {getFieldDecorator('lender.address.street', {
                initialValue: get(contract, 'lender.address.street') || get(member, 'address.street'),
                rules: [
                  {
                    required: true,
                    message: "Street can't be empty ",
                  },
                ],
              })(<Input placeholder="Street" style={{ width: '250%' }} />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="Building" {...defaultFormItemLayout}>
              {getFieldDecorator('lender.address.address', {
                initialValue: get(contract, 'lender.address.address') || get(member, 'address.address'),
              })(<Input placeholder="Building" style={{ width: '250%' }} />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item label="Town / Suburb" {...defaultFormItemLayout}>
              {getFieldDecorator('lender.address.city', {
                initialValue: get(contract, 'lender.address.city') || get(member, 'address.city'),
              })(<Input placeholder="Town / Suburb" />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="City / State" {...defaultFormItemLayout}>
              {getFieldDecorator('lender.address.state', {
                initialValue: get(contract, 'lender.address.state') || get(member, 'address.state'),
                rules: [
                  {
                    required: true,
                    message: '"City / State can\'t be empty ',
                  },
                ],
              })(<Input placeholder="City / State" />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label="Label" {...defaultFormItemLayout}>
              {getFieldDecorator('lender.address.label', {
                initialValue: get(contract, 'lender.address.label') || get(member, 'address.label'),
              })(<Input placeholder="Label" style={{ width: '250%' }} />)}
            </Form.Item>
          </Col>
        </Row>

        <FormSectionTitle title={'PARTNER CONTRACT REPRESENTATIVE'} />
        <CustomSpin spinning={fetching}>
          <Row>
            <Col span={12}>
              <Form.Item label="Representative" {...defaultFormItemLayout}>
                {getFieldDecorator('lenderRep._id', {
                  initialValue: get(contract, 'lenderRep._id'),
                  rules: [
                    {
                      required: true,
                      message: "Representative can't be empty ",
                    },
                  ],
                })(<SupplierRepSelect onChange={this.onChangeClientRep} keyAtr={'owner'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Phone" {...defaultFormItemLayout}>
                {getFieldDecorator('lenderRep.phone.label', {
                  initialValue: get(contract, 'lenderRep.phone.label'),
                  rules: [
                    {
                      required: true,
                      message: "Phone can't be empty ",
                    },
                  ],
                })(<Input placeholder="Phone" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Email" {...defaultFormItemLayout}>
                {getFieldDecorator('lenderRep.email.label', {
                  initialValue: get(contract, 'lenderRep.email.label'),
                  rules: [
                    {
                      required: true,
                      message: "Email can't be empty ",
                    },
                  ],
                })(<LenderRepEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Address" {...defaultFormItemLayout}>
                {getFieldDecorator('lenderRep.address.label', {
                  initialValue: get(contract, 'lenderRep.address.label'),
                })(<Input placeholder="Address" />)}
              </Form.Item>
            </Col>
          </Row>
        </CustomSpin>
        <FormSectionTitle title={'PARTNER BILLING REPRESENTATIVE'} />
        <CustomSpin spinning={fetching}>
          <Row>
            <Col span={12}>
              <Form.Item label="Billing Representative" {...defaultFormItemLayout}>
                {getFieldDecorator('payableRep._id', {
                  initialValue: get(contract, 'payableRep._id'),
                  rules: [
                    {
                      required: true,
                      message: " Billing Representative can't be empty ",
                    },
                  ],
                })(<SupplierRepSelect onChange={this.onChangeBillingRep} keyAtr={'owner'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Phone" {...defaultFormItemLayout}>
                {getFieldDecorator('payableRep.phone.label', {
                  initialValue: get(contract, 'payableRep.phone.label'),
                  rules: [
                    {
                      required: true,
                      message: "Phone can't be empty ",
                    },
                  ],
                })(<Input placeholder="Phone" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Email" {...defaultFormItemLayout}>
                {getFieldDecorator('payableRep.email.label', {
                  initialValue: get(contract, 'payableRep.email.label'),
                  rules: [
                    {
                      required: true,
                      message: "Email can't be empty ",
                    },
                  ],
                })(<PayableEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Address" {...defaultFormItemLayout}>
                {getFieldDecorator('payableRep.address.label', {
                  initialValue: get(contract, 'payableRep.address.label'),
                })(<Input placeholder="Address" />)}
              </Form.Item>
            </Col>
          </Row>
        </CustomSpin>
        <FormSectionTitle title={'COMPANY CONTRACT REPRESENTATIVE'} />
        <CustomSpin spinning={fetching}>
          <Row>
            <Col span={12}>
              <Form.Item label="Representative" {...defaultFormItemLayout}>
                {getFieldDecorator('companyRep._id', {
                  initialValue: get(contract, 'companyRep._id'),
                  rules: [{ required: true, message: 'Please Select a Representative!' }],
                })(<CompanyRepSelect onChange={this.onChangeCompanyRep} keyAtr={'owner'} valueAtr={'name'} />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Phone" {...defaultFormItemLayout}>
                {getFieldDecorator('companyRep.phone.label', {
                  initialValue: get(contract, 'companyRep.phone.label'),
                  rules: [
                    {
                      required: true,
                      message: "Phone can't be empty ",
                    },
                  ],
                })(<Input placeholder="Phone" />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Email" {...defaultFormItemLayout}>
                {getFieldDecorator('companyRep.email.label', {
                  initialValue: get(contract, 'companyRep.email.label'),
                  rules: [
                    {
                      required: true,
                      message: "Email can't be empty ",
                    },
                  ],
                })(<CompanyRepEmailSelect valueAtr={'label'} keyAtr={'label'} placeholder="Email" />)}
              </Form.Item>
            </Col>
          </Row>
        </CustomSpin>
        {type !== 'update' && <InfoText text={'Finance Account details are pre-loaded from Lender default contacts'} />}
      </Form>
    )
  }
}

export default compose(Form.create(), withLoadingSection)(Communication)
